import reactSizes from 'react-sizes';

const mapSizesToProps = ({
  width
}) => ({
  width
});
const withSizes = Component => {
  return reactSizes(mapSizesToProps)(Component);
};
const WithSizesConsumer = reactSizes(mapSizesToProps)(props => {
  return props.children(props);
});

export { WithSizesConsumer, withSizes };
